import { render, staticRenderFns } from "./TreeNodeCoursePath.vue?vue&type=template&id=dfb34bfa&"
import script from "./TreeNodeCoursePath.vue?vue&type=script&lang=js&"
export * from "./TreeNodeCoursePath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports